import { useEffect, useState } from "react";
import { useGetAvailableTariffByScheduleV2 } from "@/api/traveler";
import {
  ActivityTariffAvailability,
  ActivityTariffAvailabilityTariffType,
  ScheduleHoursRangeVm,
} from "@/model";

export const useSchedule = (selectedHour: ScheduleHoursRangeVm) => {
  const { mutate: mutateTariffs, isLoading: loadingTariffs } =
    useGetAvailableTariffByScheduleV2();
  const [groups, setGroups] = useState<
    {
      tariffType: ActivityTariffAvailabilityTariffType | undefined;
      tariffs: ActivityTariffAvailability[];
      tariffId: number;
    }[]
  >([]);

  useEffect(() => {
    setGroups([]);
    if (selectedHour.date && selectedHour.schedule?.id) {
      mutateTariffs(
        {
          data: {
            reservationDate: selectedHour.date,
            scheduleId: selectedHour.schedule?.id,
          },
        },
        {
          onSuccess: (data) => {
            const auxGroups = [];
            for (let i = 0; i < data.length; i++) {
              if (data[i].tariffType) {
                let j = 0;
                let found = false;
                while (j < auxGroups.length && !found) {
                  if (auxGroups[j].tariffType === data[i].tariffType) {
                    found = true;
                  }
                  j++;
                }
                if (!found) {
                  auxGroups.push({
                    tariffType: data[i].tariffType,
                    tariffs: [data[i]],
                    tariffId: data[i].id,
                  });
                } else {
                  auxGroups[j - 1].tariffs.push(data[i]);
                }
              }
            }
            setGroups(auxGroups);
          },
        },
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedHour]);
  return {
    groups,
    loadingTariffs,
  };
};
